import { FactionType, Player } from "~/business";
import { ModalNames } from "~/jsx/context/ModalNames";
import { Spacing } from "~/jsx/theme";
import { Colors } from "~/jsx/theme/Colors";
import { isLocalhost, useModal, useSession } from "~/utils";
import { XButton } from "./XButton";
import { XPlayerLeaderDescription } from "./XPlayerLeaderDescription";
import { XPlayerIcon } from "./XPlayerIcon";
import { XPlayerMeaples } from "./XPlayerMeaples";
import { XPlayerName } from "./XPlayerName";
import { XPlayerResources } from "./XPlayerResources";
import { XResources } from "./XResources";
import { XTypography } from "./XTypography";
import { XFactionVictoryPoint, XHourglassSvg, XSignetSvg } from "./svg";
import { useGame } from "~/app";

const resourceWidth = 18;
const internalBorder = `solid 1px ${Colors.grey.c3}`;

export const XOpponentInfos = ({
  player,
  isCurrent,
  isFirst: isFirstPlayer,
}: {
  player: Player;
  isCurrent: boolean;
  isFirst: boolean;
}) => {
  const { show: showPlayerLeader } = useModal(ModalNames.playerLeader);
  const { setValue } = useSession();

  const { totalVictoryPoints, name, intrigueCards, hand } = player;
  const factionsWithPoint = Object.values(FactionType).filter((faction) => {
    const { hasPoint } = player.getFactionAffinity(faction);
    return hasPoint;
  });

  const onImpersonate = () => {
    setValue({
      user: {
        id: player.id,
        name: player.name,
      },
    });
    location.reload();
  };

  return (
    <div
      style={{
        position: "relative",
        backgroundColor: Colors.grey.background,
        border: "1px solid rgba(0, 0, 0, 0.25)",
        borderTop: "none",
        boxShadow: "4px 4px 4px rgba(0, 0, 0, 0.25)",
        borderRadius: "12px 0px 0px 12px",
        display: "flex",
        flexDirection: "column",
        width: 400,
        overflow: "hidden",
        alignItems: "flex-end",
      }}
    >
      <div
        style={{
          borderBottom: internalBorder,
          width: "100%",
          display: "flex",
          alignItems: "center",
          height: 60,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            padding: Spacing.px8,
            width: Spacing.px64,
            justifyContent: "flex-end",
            borderRight: internalBorder,
            height: 60,
          }}
        >
          <XResources
            resources={{
              victory: totalVictoryPoints,
            }}
            width={resourceWidth}
          />
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: Spacing.px4,
            alignItems: "center",
            padding: Spacing.px8,
          }}
        >
          {factionsWithPoint.map((faction) => (
            <XFactionVictoryPoint key={faction} faction={faction} width={28} />
          ))}
        </div>
        {isCurrent && <XHourglassSvg width={24} />}
        <XTypography
          style={{
            padding: Spacing.px8,
            display: "flex",
            justifyContent: "flex-end",
            alignItems: "center",
            flex: 1,
          }}
          typographyStyle={{
            margin: 0,
          }}
        >
          <XPlayerName name={name} />{" "}
          <XPlayerIcon playerId={player.id} width={resourceWidth} />
          <XButton
            style={{ display: "inline-block", marginLeft: Spacing.px8 }}
            onClick={() =>
              showPlayerLeader({
                dynamicContent: <XPlayerLeaderDescription player={player} />,
              })
            }
          >
            <XSignetSvg
              width={18}
              style={{ verticalAlign: "middle", marginLeft: Spacing.px4 }}
            />
          </XButton>
        </XTypography>
      </div>
      <div style={{ display: "flex", width: "100%", height: 45 }}>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            borderRight: internalBorder,
            padding: Spacing.px8,
            width: Spacing.px64,
            justifyContent: "flex-end",
          }}
        >
          {isLocalhost() && <XButton onClick={onImpersonate}>As</XButton>}
          {isFirstPlayer && (
            <XTypography
              style={{
                border: "solid 1px black",
                borderRadius: "10em",
                backgroundColor: "white",
                width: 32,
                height: 32,
                padding: 2,
                textAlign: "center",
              }}
              typographyStyle={{ lineHeight: "32px" }}
            >
              1st
            </XTypography>
          )}
        </div>
        <div
          style={{
            padding: Spacing.px8,
            borderRight: internalBorder,
            flex: 1,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <XPlayerMeaples player={player} meapleWidth={18} />
          <XResources
            resources={{
              card: hand.length,
              intrigueCard: intrigueCards.length,
            }}
            width={resourceWidth}
          />
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            gap: 4,
            padding: Spacing.px8,
            alignItems: "flex-end",
          }}
        >
          <XPlayerResources player={player} />
        </div>
      </div>
    </div>
  );
};
